__turbopack_context__.v({
  "active": "Search-module__vcJsMq__active",
  "compactSearch": "Search-module__vcJsMq__compactSearch",
  "disabled": "Search-module__vcJsMq__disabled",
  "dropdownWrapper": "Search-module__vcJsMq__dropdownWrapper",
  "first": "Search-module__vcJsMq__first",
  "iconWrapper": "Search-module__vcJsMq__iconWrapper",
  "makeModelWrapper": "Search-module__vcJsMq__makeModelWrapper",
  "makeValue": "Search-module__vcJsMq__makeValue",
  "modalBody": "Search-module__vcJsMq__modalBody",
  "modalContainer": "Search-module__vcJsMq__modalContainer",
  "noParent": "Search-module__vcJsMq__noParent",
  "postcodeWrapper": "Search-module__vcJsMq__postcodeWrapper",
  "rotate": "Search-module__vcJsMq__rotate",
  "searchCol": "Search-module__vcJsMq__searchCol",
  "searchCtaCol": "Search-module__vcJsMq__searchCtaCol",
  "searchWrapper": "Search-module__vcJsMq__searchWrapper",
  "searchWrapperRow": "Search-module__vcJsMq__searchWrapperRow",
  "skeleton": "Search-module__vcJsMq__skeleton",
  "wrapperWithText": "Search-module__vcJsMq__wrapperWithText",
});
